import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WalletService } from 'src/app/service/wallet.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ErrorModalComponent } from '../../error-modal/error-modal.component';

@Component({
  selector: 'app-affiliate-withdraw-modal',
  templateUrl: './affiliate-withdraw-modal.component.html',
  styleUrls: ['./affiliate-withdraw-modal.component.scss'],
})
export class AffiliateWithdrawModalComponent {
  @Input() walletDetails: any;
  withdrawForm: any = FormGroup;

  errorModalRef?: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private walletService: WalletService
  ) {}

  ngOnInit() {
    this.resetForm();
  }

  close() {
    this.modalService.hide();
  }

  withdrawRequest(form: FormGroup) {
    if (form.valid) {
      this.walletService.submitWithdrawal(form.value).subscribe((res) => {
        if (res) {
          this.openErrorModal(
            'Request Submitted',
            'Your request has been sent successfully.',
            true,
            3000,
            'success'
          );
        }
        this.close();
      });
    } else {
      this.openErrorModal(
        'Form Incomplete',
        'Fill all fields before submitting.',
        true,
        3000,
        'warning'
      );
    }
  }

  resetForm() {
    this.withdrawForm = this.fb.group(
      {
        account_number: [null, [Validators.required]],
        confirm_account_number: [null, [Validators.required]],
        ifsc_code: [null, [Validators.required]],
        amount: [null, [Validators.required]],
      },
      {
        validator: this.accountMatchValidator,
      }
    );
  }

  accountMatchValidator(group: FormGroup) {
    const accno = group.controls['account_number'].value;
    const confirmAccno = group.controls['confirm_account_number'].value;
    if (accno !== confirmAccno) {
      group.controls['confirm_account_number'].setErrors({ accMismatch: true });
    } else {
      group.controls['confirm_account_number'].setErrors(null);
    }
  }
  openErrorModal(
    headData?: any,
    subHeadData?: any,
    autoClose?: any,
    autoCloseTime?: number,
    modalColor?: string
  ) {
    const initialState = {
      headData: headData,
      subHeadData: subHeadData,
      autoClose: autoClose, // Enable auto-close
      autoCloseTime: autoCloseTime, // Close after 3 seconds
      modalColor: modalColor,
    };

    this.errorModalRef = this.modalService.show(ErrorModalComponent, {
      class: 'modal-dialog-centered error-modal-style',
      animated: true,
      ignoreBackdropClick: true,
      initialState,
    });
  }
}
